import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding: 3rem 5rem;
  max-width: 1200px;
  margin: 0 auto;
  line-height: 1.6;
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.background};

  h2 {
    color: ${({ theme }) => theme.text};
  }

  h4 {
    margin-top: 2rem;
    font-weight: bold;
    color: ${({ theme }) => theme.headerText};
  }

  iframe {
    margin-top: 1rem;
    max-width: 100%;
    border-radius: 6px;
  }

  p {
  color: ${({ theme }) => theme.text};
  }
`;

export default function SurveyApp() {
  return (
    <Section className="survey-section">
      <h2>Canadian Beef Cattle Survey</h2>
      <article>
        <h4>CSB Survey: A Summary</h4>
        <p>
          A survey is a set of fields pre-defined by the Beef Cattle Survey research group.<br />
          Each survey has data provided by 5 different sites or groups.<br />
          Each site will provide the data for different years.<br />
          The data will be provided in a spreadsheet format. There will be very little manual entry.<br />
          The Survey form, when opened, will summarize what is required for data to be sent by a site.<br />
          Once a survey form is opened you will see several different sections of what you can do.<br />
        </p>

        <h4>Who gets to work on a survey?</h4>
        <p>
          Only users designated by Dr. Sheryl Gow as Project Managers will have access to Survey Management.<br />
          Also, users from there designated site will in time be able to add there own surveys.<br />
          These users will not be able to see other sites data.
        </p>

        <h4>CSB Survey: Introduction</h4>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/uEwUU0P-0kk"
          title="CSB Introduction"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <h4>CSB Survey: Starting the Application</h4>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/RWWh9yFn0h4"
          title="CSB Starting the application"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <h4>CSB Survey: Logging In</h4>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/zuZgSza1PB8"
          title="CSB Logging into the application"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <h4>CSB Survey: Menu Tree</h4>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/videoseries?list=PLIRCu9B4HsTZNqSc7KjshjrZLl_4C1tMH"
          title="CSB Menu Tree"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <h4>CSB Survey: Navigate Survey Data</h4>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/T75EZfbrkNI"
          title="CSB Navigating the Survey Data"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <h4>CSB Survey: Setting up the Templates</h4>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/aVwxzDHniEw"
          title="CSB Setting up Templates"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <h4>CSB Survey: Uploading the Source Data</h4>
        <h4>CSB Survey: Production Lot Data</h4>
        <h4>CSB Survey: Production Lot Data - General</h4>
        <h4>CSB Survey: Production Lot Data - Weights</h4>
        <h4>CSB Survey: Production Lot Data - Dates and Time</h4>
        <h4>CSB Survey: Production Lot Data - Frequency Data</h4>
        <h4>CSB Survey: Drug Data - Associated with each Production Lot</h4>
        <h4>CSB Survey: Drug Data - Drug Route Bolus</h4>
        <h4>CSB Survey: Drug Data - Drug Route Feed</h4>
        <h4>CSB Survey: Drug Data - Drug Route Injectable</h4>
        <h4>CSB Survey: Drug Data - Drug Route Water</h4>
        <h4>CSB Survey: Data Governance</h4>
        <h4>CSB Survey: Reports</h4>
      </article>
    </Section>
  );
}
